export const InformationsAnzeigeTestIds = {
  infoDisplay: 'info_display',
  infoIconBackground: 'info_icon_background',
  infoIcon: 'info_icon',
  infoText: 'info_text'
} as const;
